import { useEffect, useRef, useState } from 'react';
import AppDocumentEdit from './AppDocumentEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { columnsheadId } from '../../universal/columnshead';
import { Select, Space, Tooltip } from 'antd';
import fetchApi from '../../../utils/api/fetchApi';
import getList from '../../../utilsTsx/universal/getList';

const WebComponent = (props: any) => {
    const ref = useRef<any>(undefined);
    const apiId = 'appDocument';
    const [appVersionData, setAppVersionData] = useState<any>();
    /** 后端数据defaultService */
    const [defaultService, setDefaultService] = useState<string>('');
    const [fethcData, setFethcData] = useState<any>();

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService;
            setDefaultService(urlService);
            setFethcData(() => ref.current.fetchData);
        }
        fetchApi.GET(urlService,
            {
                apiId: 'appVersion',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setAppVersionData([{ id: 'allAppVersion', name: '所有版本' }, ...res.data]);
                }
            })
    }, []);

    //表头
    const columnsHead = [
        {
            title: '版本',
            dataIndex: 'appVersion',
            render: (val: any) => val?.versionName
        },
        {
            title: '主题',
            dataIndex: 'title'
        },
        {
            title: '内容',
            dataIndex: 'content',
            render: (val: any) => <Tooltip placement="topLeft" title={`${val.substring(0, 50)}......`}>{
                val ? (val.length >= 20 ? `${val.substring(0, 20)}......` : val) : ''
            }</Tooltip>
        },
        {
            title: '排序',
            dataIndex: 'sorting'
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '应用文档',
        apiId,
        columns,
        editOptions: {
            Editor: AppDocumentEdit
        },
        expandableOptions: {
            subDataName: 'children',
            isSameMainDisplayOptions: true,
            isTree: true
        },
        sendPageData: {
            sendPageData: { appId: 'allAppVersion' }
        }
    };

    return (
        <> <Space>
            <Select
                showSearch
                placeholder="版本"
                optionFilterProp="children"
                defaultValue={'allAppVersion'}
                onChange={(e) => {
                    fethcData({
                        apiId,
                        sendPageData: { appVersionId: e }
                    });
                }}
                style={{ width: 130 }}
                filterOption={(input, option: any) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                {getList.general(appVersionData, {
                    setItemNameFun: (item) => {
                        const { id, name, versionName, app } = item;
                        if (id === 'allAppVersion') {
                            return { id, name }
                        }
                        return { id, name: `${versionName}【${app?.name}】` }
                    }
                })}
            </Select>
        </Space>
            <> </>
            <WebUniversal {...extendProps} ref={ref} />
        </>
    )
}

export default WebComponent;
